import React, { ReactElement, useState } from "react"
import {
  Flex, IconProps, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text,
} from "@chakra-ui/react"
import UpgradeAlert from "components/elements/UpgradeAlert"

type Props = {
  icon: (props: IconProps) => ReactElement
  title: string
  description: string
  alertText?: string
  children: ReactElement
}

const UpgradeGateModal = ({
  icon: Icon,
  title,
  description,
  alertText = "This feature requires a Corporate Subscription.",
  children,
}: Props) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      {React.cloneElement(children, {
        // Preserve any existing onClick by chaining — the wrapper's own
        // `setOpen(true)` always runs.
        onClick: (e: React.MouseEvent) => {
          children.props.onClick?.(e)
          setOpen(true)
        },
      })}
      <Modal isOpen={open} onClose={() => setOpen(false)} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody py={10} px={6}>
            <Flex flexDirection="column" alignItems="center" textAlign="center">
              <Icon boxSize={10} color="blue.500" mb={3} />
              <Text fontSize="2xl" fontWeight="semibold" mb={6}>{title}</Text>
              <Text fontSize="md" maxW="xs" mb={8}>{description}</Text>
              <UpgradeAlert text={alertText} />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default UpgradeGateModal
